<template>
  <div>
    <cover :topImg="topImg"/>
    <div class="type-center">
      <div class="product white-bg flex">
        <div class="product-tab flex-shrink-0">
          <div
              class="product-tab-item mb25 ptb5 align-center"
              @click="productId = item.id;productDetail = item"
              :class="{active: item.id == productId}"
              v-for="(item, index) in productList"
              :key="index">
            {{ $i18n.locale == 'zh' ? item.name : item.nameEn }}
          </div>
        </div>
        <div class="product-content">
          <!--<div>{{ $i18n.locale == 'zh' ? productDetail.name : productDetail.nameEn }}</div>-->
          <div v-html="$i18n.locale == 'zh' ? productDetail.content : productDetail.contentEn"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getProducts} from "@/api/api";

export default {
  name: "",
  data() {
    return {
      topImg: require('@/assets/image/aboutUs/topImg.png'),
      classifyId: '',
      productList: [],
      productId: '',
      productDetail: {},
    };
  },
  watch: {
    $route(val) {
      this.classifyId = val.query.id;
      this.getProducts()
    },
  },
  mounted() {
    this.classifyId = this.$route.query.id;
    this.getProducts()
  },
  methods: {
    // 获取产品
    getProducts() {
      getProducts({
        classifyId: this.classifyId
      }).then(res => {
        if (res.code == 1) {
          this.productList = res.data || [];
          if (this.productList.length) {
            this.productId = this.productList[0].id;
            this.productDetail = this.productList[0] || {};
          }
        }
      });
    }
  },
}
</script>
<style scoped lang="scss">
.product {
  margin-top: -108px;
  width: 100%;

  &-tab {
    width: 201px;
    margin: 45px 10px;

    &-item {
      background: #DEDEDE;
      font-weight: 400;
      font-size: 20px;
      color: #46494D;
    }

    &-item:hover {
      cursor: pointer;
      background: #3a74ed;
      color: #fff;
    }

    &-item.active {
      background: linear-gradient(270deg, #053EB2 0%, #3C78F1 100%);
      color: #fff;
    }
  }

  &-content {
    border-left: 1px solid rgba(0, 0, 0, 0.16);
  }
}
</style>
